<div #container role="region" aria-live="polite" class="eui-growl {{styleClass}} eui-growl--{{position}}" (click)="onClick()" attr.data-e2e="{{ e2eAttr }}">
    <div #msgel *ngFor="let msg of value"
                class="eui-growl-item-container eui-u-anim eui-u-anim--fast"
                [ngClass]="{'eui-growl-item-container--info':msg.severity == 'info',
                'eui-growl-item-container--warning':msg.severity == 'warning',
                'eui-growl-item-container--danger':msg.severity == 'danger',
                'eui-growl-item-container--success':msg.severity == 'success',
                'eui-growl--sticky':sticky}"
                [class.eui-u-anim--slideInUp]="position === 'bottom-left' || position === 'bottom-center' || position === 'bottom-right'"
                [class.eui-u-anim--slideInDown]="position === 'top-left' || position === 'top-center' || position === 'top-right'">
        <div class="eui-growl-item">
            <span class="eui-growl-item-image eui-icon eui-icon-3x"
                  [ngClass]="{'eui-icon-info-circle':msg.severity == 'info',
                        'eui-icon-exclamation-circle':msg.severity == 'warning',
                        'eui-icon-ecl-error':msg.severity == 'danger',
                        'eui-icon-check-circle':msg.severity == 'success'}">
            </span>
            <div class="eui-growl-item-message">
                <span class="eui-growl-item-message-title">{{msg.summary}}</span>
                <p class="eui-growl-item-message-detail" [innerHTML]="msg.detail"></p>
            </div>
            <div class="eui-growl-item-close eui-icon eui-icon-close-m" (click)="remove(msg,msgel)"></div>
        </div>
    </div>
</div>
